module.exports = __webpack_public_path__ + "img/checkbox-unchecked.2ddbf4d5.svg";